// Mirrors backend/deps.py GRADE_OPTIONS + SPORT_OPTIONS. Keep this list in sync
// with the backend tuples — the backend rejects anything not in its set.

export const GRADE_OPTIONS = [
    { value: "kindergarten", label: "Kindergarten" },
    { value: "1st", label: "1st grade" },
    { value: "2nd", label: "2nd grade" },
    { value: "3rd", label: "3rd grade" },
    { value: "4th", label: "4th grade" },
    { value: "5th", label: "5th grade" },
    { value: "6th", label: "6th grade" },
    { value: "7th", label: "7th grade" },
    { value: "8th", label: "8th grade" },
    { value: "9th", label: "9th grade (Freshman)" },
    { value: "10th", label: "10th grade (Sophomore)" },
    { value: "11th", label: "11th grade (Junior)" },
    { value: "12th", label: "12th grade (Senior)" },
    { value: "college", label: "College" },
];

// Sport options grouped for the picker. The `value` is the slug we persist.
export const SPORT_GROUPS = [
    {
        group: "Team — Field",
        sports: [
            { value: "football", label: "Football" },
            { value: "soccer", label: "Soccer" },
            { value: "baseball", label: "Baseball" },
            { value: "softball", label: "Softball" },
            { value: "lacrosse", label: "Lacrosse" },
            { value: "field_hockey", label: "Field Hockey" },
            { value: "rugby", label: "Rugby" },
        ],
    },
    {
        group: "Team — Court",
        sports: [
            { value: "basketball", label: "Basketball" },
            { value: "volleyball", label: "Volleyball" },
            { value: "water_polo", label: "Water Polo" },
        ],
    },
    {
        group: "Ice & Snow",
        sports: [
            { value: "ice_hockey", label: "Ice Hockey" },
            { value: "figure_skating", label: "Figure Skating" },
            { value: "skiing", label: "Skiing" },
            { value: "snowboarding", label: "Snowboarding" },
        ],
    },
    {
        group: "Racquet & Club",
        sports: [
            { value: "tennis", label: "Tennis" },
            { value: "pickleball", label: "Pickleball" },
            { value: "golf", label: "Golf" },
        ],
    },
    {
        group: "Combat",
        sports: [
            { value: "wrestling", label: "Wrestling" },
            { value: "martial_arts", label: "Martial Arts / MMA" },
            { value: "boxing", label: "Boxing" },
        ],
    },
    {
        group: "Aesthetic & Artistic",
        sports: [
            { value: "gymnastics", label: "Gymnastics" },
            { value: "cheer", label: "Cheer" },
            { value: "dance", label: "Dance" },
            { value: "diving", label: "Diving" },
        ],
    },
    {
        group: "Endurance & Individual",
        sports: [
            { value: "track_and_field", label: "Track & Field" },
            { value: "cross_country", label: "Cross Country" },
            { value: "swimming", label: "Swimming" },
            { value: "rowing", label: "Rowing" },
            { value: "triathlon", label: "Triathlon" },
            { value: "equestrian", label: "Equestrian" },
        ],
    },
    {
        group: "General",
        sports: [
            { value: "multi_sport", label: "Multi-sport" },
            { value: "other", label: "Other (specify)" },
        ],
    },
];

// Flat lookup map: slug → display label.
export const SPORT_LABELS = Object.fromEntries(
    SPORT_GROUPS.flatMap((g) => g.sports.map((s) => [s.value, s.label]))
);

export const GRADE_LABELS = Object.fromEntries(
    GRADE_OPTIONS.map((g) => [g.value, g.label])
);
